// src/belediye/components/applications/BasvuruCipSeridi.js
//
// FAZ-97 madde 3 — BAŞVURU ÇİP ŞERİDİ, TEK GÖVDE.
//
// Kullanıcı (2026-08-01): "Yönlendirilenler kısmını en sona almışsın ya, burada
// kalabilir ama buraya tıklayınca diğer sekmeler kaybolmasın; diğer sekmeler
// olduğu yerde kalsın. Arama, filtreler, birimler falan yine yönlendirilen
// başvurulara ait olsun ama sekmeler kaybolmasın. Sekmelerden birine, yeniye
// tıklayınca da direkt yeni sayfasına geçsin."
//
// TEŞHİS: "Yönlendirilenler" bir ÇİP ama hedefi ayrı bir SAYFA
// (RedirectedApplicationsPage). O sayfanın kendi başlık yapısı vardı ve şerit
// hiç yoktu → çipe basınca şerit ekrandan kayboluyor, başka bir statüye dönmek
// için geri tuşu gerekiyordu.
//
// PAYLAŞILAN OLAN YALNIZ ŞERİT. Arama/filtre/birim araç satırı her sayfanın
// kendi işi olarak kalır — kullanıcı bunu açıkça söyledi.

import React from "react";
import {
  InboxArrowDownIcon,
  WrenchScrewdriverIcon,
  CheckCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";

/* Sekme sözleşmesi. Yönlendirilen (redirected) yapısı farklı olduğu için
   STATÜ değil KAPSAM çipi olarak ayrı tutulur. */
export const STATUS_TABS = [
  { status: "yeni", label: "Yeni", icon: InboxArrowDownIcon },
  { status: "işleme_alındı", label: "İncelemedeki", icon: WrenchScrewdriverIcon },
  { status: "çözüldü", label: "Çözülen", icon: CheckCircleIcon },
  { status: "çözülemedi", label: "Çözülemeyen", icon: XCircleIcon },
];

/* FAZ-89 — KAPSAM ÇİPLERİ.
   Statü değil: ayrı ROTA + ayrı İZİN. Bu yüzden STATUS_TABS'e karıştırılmaz;
   şeritte ince bir ayraçtan sonra ve farklı renkle çizilir. Rol adı geçmez
   (K-7: yuvalar rol string'inden değil izinden türer). */
export const KAPSAM_TABS = [
  {
    key: "yonlendirilen",
    label: "Yönlendirilenler",
    to: "/yonetim/yonlendirilen-basvurular",
    permission: "staff.forwardlog.report.view",
  },
];

/**
 * @param {string|null} aktifStatus   seçili statü (Yönlendirilenler'de null)
 * @param {string|null} aktifKapsam   seçili kapsam çipi anahtarı
 * @param {object} sayilar            statü → adet (yoksa rozet çizilmez)
 * @param {Function} onStatus         statü çipine basıldı
 * @param {Array} kapsamCipleri       izinle süzülmüş kapsam çipleri
 * @param {Function} onKapsam         kapsam çipine basıldı
 * @param {React.ReactNode} ek        şeridin sonuna eklenecek (ör. onay toggle)
 */
export default function BasvuruCipSeridi({
  aktifStatus = null,
  aktifKapsam = null,
  sayilar = {},
  onStatus,
  kapsamCipleri = [],
  onKapsam,
  ek = null,
}) {
  return (
    <>
      <div
        className="applications-tabs"
        role="tablist"
        aria-label="Başvuru durumları"
      >
        {STATUS_TABS.map((tab) => {
          const active = tab.status === aktifStatus;
          const c = sayilar[tab.status];
          const TabIcon = tab.icon;
          return (
            <button
              key={tab.status}
              type="button"
              role="tab"
              aria-selected={active}
              className={`applications-tab${active ? " active" : ""}`}
              onClick={() => onStatus(tab.status)}
            >
              <TabIcon className="applications-tab-icon" />
              <span className="applications-tab-label">{tab.label}</span>
              {typeof c === "number" && (
                <span className="applications-tab-count">{c}</span>
              )}
            </button>
          );
        })}

        {/* Kapsam çipi. Rota değiştirir, statü SÜZMEZ; bu yüzden role="tab"
            değil düz düğme ve ayraçla ayrılmış. */}
        {kapsamCipleri.length > 0 && (
          <span className="applications-tab-ayrac" aria-hidden="true" />
        )}
        {kapsamCipleri.map((k) => (
          <button
            key={k.key}
            type="button"
            className={`applications-tab applications-tab--kapsam${
              aktifKapsam === k.key ? " active" : ""
            }`}
            aria-current={aktifKapsam === k.key ? "page" : undefined}
            onClick={() => onKapsam(k)}
          >
            <span className="applications-tab-label">{k.label}</span>
          </button>
        ))}
      </div>
      {ek}
    </>
  );
}
